<template>
  <li
    class="login-profile language-select d-block logged-in-nav"
    @click="openprofile()"
  >
    <div class="select-title">
      <div class="profile-img">
        <a href="javascript:void(0)">
          <img :src="userAvatar" class="img-fluid bg-img" alt="user" />
        </a>
      </div>
      <div class="profile-detail">
        <a href="javascript:void(0)" class="profile-name">
          <h6>{{ userName }}</h6>
          <svg width="12" height="6" fill="none">
            <use xlink:href="#downArrowGray" />
          </svg>
        </a>
        <div class="profile-balance" v-if="isModuleEnable('Loyalty')">
          <svg width="19" height="17" fill="none">
            <use xlink:href="#currencyWarning" />
          </svg>
          <span>{{ currency }} {{ Num.price(loyalty_balance) }}</span>
        </div>
      </div>
    </div>
    <ul
      class="language-dropdown"
      :class="{ open: openprofileDropdown }"
      @mouseleave="closeProfile()"
    >
      <li
        :class="{
          active: $route.name === 'profile.personal-info',
        }"
      >
        <router-link
          class="d-block w-100"
          :to="{ name: 'profile.personal-info' }"
        >
          <h4>{{ _T('Profile') }}</h4>
        </router-link>
      </li>
      <li
        :class="{
          active: $route.name === 'profile.ongoing-orders',
        }"
      >
        <router-link
          class="d-block w-100"
          :to="{ name: 'profile.ongoing-orders' }"
        >
          <h4>{{ _T('Orders') }}</h4>
        </router-link>
      </li>
      <li
        :class="{ active: $route.name === 'profile.wallet' }"
        v-if="isModuleEnable('Loyalty')"
      >
        <router-link class="d-block w-100" :to="{ name: 'profile.wallet' }">
          <h4>{{ _T('My Cashback') }}</h4>
        </router-link>
      </li>
      <li @click="$bvModal.show('log-out')">
        <a class="logout-user d-block w-100">
          <h4>{{ _T('Logout') }}</h4>
        </a>
      </li>
    </ul>
    <confirm-logout />
  </li>
</template>

<script>
import { mapGetters } from 'vuex'
import ConfirmLogout from '@/components/Modals/ConfirmLogout'

export default {
  name: 'LoggedInNav',
  components: {
    ConfirmLogout,
  },
  data() {
    return {
      openprofileDropdown: false,
      classicheader: ['faq'],
    }
  },
  computed: {
    ...mapGetters([
      'userName',
      'userAvatar',
      '_T',
      'loyalty_balance',
      'isModuleEnable',
    ]),
    classicHeader() {
      if (
        this.$route.matched.some(({ name }) =>
          this.classicheader.includes(name)
        )
      ) {
        return true
      }
      return false
    },
  },
  methods: {
    openprofile() {
      this.openprofileDropdown = !this.openprofileDropdown
    },
    closeProfile() {
      this.openprofileDropdown = false
    },
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .login-profile {
    .language-dropdown.open {
      text-align: right;
    }
  }
  .profile-detail {
    .profile-name {
      h6 {
        margin-left: 0.5rem;
        margin-right: unset;
      }
    }
    .profile-balance {
      svg {
        margin-right: unset;
        margin-left: 0.375rem;
      }
    }
  }
}
.login-profile {
  display: flex;
  align-items: center;
  .select-title {
    display: flex;
    align-items: center;
  }
  .language-dropdown {
    top: 2.5rem;
    z-index: 3;
    li {
      a {
        h4 {
          color: $font-color;
          transition: 0.3s ease;
        }
      }
      &:hover {
        background-color: $transparent;
        a {
          h4 {
            color: $color-primary;
            transition: 0.3s ease;
          }
        }
      }
    }
    &.open {
      top: 3.125rem;
    }
  }
  .profile-img {
    margin-right: 0.75rem;
    position: relative;
    .bg-size,
    img {
      width: 2.5rem;
      height: 2.5rem;
      border-radius: 100%;
      border: $px2 solid $light-border;
    }
    &:after {
      content: '';
      position: absolute;
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 100%;
      background-color: $color-primary;
      right: 0.188rem;
      top: 0.188rem;
    }
  }
  .profile-detail {
    .profile-name {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      h6 {
        line-height: 1.188rem;
        color: $font-color;
        font-weight: 500;
        margin-bottom: 0;
        margin-right: 0.5rem;
      }
    }
    .profile-balance {
      display: flex;
      align-items: center;
      margin-top: 0.375rem;
      svg {
        margin-right: 0.375rem;
      }
      span {
        font-size: 0.75rem;
        line-height: 1.063rem;
        letter-spacing: 0.036rem;
        color: $color-primary;
        text-transform: uppercase;
        font-weight: 500;
      }
    }
  }
}
.language-dropdown {
  position: absolute;
  top: 0.75rem;
  right: 0;
  background-color: $white;
  width: 10.625rem;
  box-shadow: 0 3px 15px rgba($black, 0.1);
  padding: 0.75rem 0.313rem;
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s ease;
  z-index: 99;
  li {
    display: flex;
    align-items: center;
    padding: 0.5rem 0.625rem;
    border-radius: 0.125rem;
    cursor: pointer;
    transition: all 0.5s ease;
    img,
    svg {
      width: 1.125rem;
      margin-right: 0.938rem;
    }
    &:after {
      display: none;
    }
    h4 {
      margin-bottom: 0;
      text-transform: capitalize;
      font-weight: 500;
      font-size: 1rem;
    }
    &.active {
      h4 {
        color: $color-primary;
        transition: all 0.5s ease;
        font-weight: 600;
      }
    }
    &:hover {
      background: $color-primary;
      color: $white;
      transition: all 0.5s ease;
    }
  }
  &.open {
    opacity: 1;
    visibility: visible;
    top: 1.875rem;
    transition: all 0.5s ease;
    z-index: 3 !important;
  }
}
</style>
